<script setup>
import { ExternalLink } from 'lucide-vue-next';
</script>

<template>
<div class="nav-wrapper"> 
    <div class="hamburger-menu" @click="open" :class="{open: isOpen}">
        <span class="line top"></span>
        <span class="line middle"></span>
        <span class="line bottom"></span>
    </div>
  <nav id="nav" :class="{open: isOpen}">
    <a href="#" id="logo" class="link" @click="isOpen = false">
        <img src="../assets/logo.png" alt="Cyclone RoboSub Logo" id="logo-icon" decoding="async" :style="{transform: `rotate(${rotation}deg)`}">
    </a>
    <!-- <a href="#" id="home-link" class="link" @click="isOpen = false">Home</a> -->
    <a href="#" @click.prevent="scrollTo" data-target="about" id="about-link" class="link">About</a>
    <a href="#" @click.prevent="scrollTo" data-target="robot" id="robots-link" class="link">Our Robot</a>
    <a href="#" @click.prevent="scrollTo" data-target="sponsors" id="sponsors-link" class="link">Sponsors</a>
    <a href="#" @click.prevent="scrollTo" data-target="join-section" id="teams-link" class="link">Team</a>
    <a id="branding-link" class="link" :href="$store.state.general.branding" target="_blank">
        Branding
        <ExternalLink :size="14" :stroke-width="3"/>
    </a>
    <a href="#" @click.prevent="scrollTo" data-target="contact" id="contact-link" class="link">Contact Us</a>
    <a id="donate-link" class="link" :href="$store.state.general.donate" target="_blank">
        Donate
        <ExternalLink :size="14" :stroke-width="3"/>
    </a>
  </nav>
</div>
</template>

<script>
export default {
    name: "NavBar",
    data(){
        return{
            isOpen: false,
            rotation: 0,
        };
    },
    methods: {
        scrollTo(e){
            // console.log(e.currentTarget.dataset)
            const targetEl = document.getElementById(e.currentTarget.dataset.target);
            
            if (targetEl) {
                targetEl.scrollIntoView({
                    behavior: "smooth", 
                    block: "start", 
                    inline: "nearest"
                });
                
                // Allow the section to receive programmatic focus
                targetEl.setAttribute("tabindex", "-1");
                // Immediately transfer focus, preventing it from cancelling the smooth scroll visually
                targetEl.focus({ preventScroll: true });
            }
            
            this.isOpen = false;
        },
        open(){
            // console.log("Clicked")
            this.isOpen = !this.isOpen;
        },
        handleScroll() {
        // console.log("Scroll event triggered");
        // console.log("Current this:", this);
        // if (this && this.rotation !== undefined) {
            const scrollPosition = window.scrollY;
            this.rotation = (-scrollPosition / 3) ;
            // console.log("Updated rotation:", this.rotation);
        // } else {
        //     console.error("Component is undefined or rotation is not initialized");
        // }
    }
    },
    mounted() {
        this.handleScroll = this.handleScroll.bind(this);
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }
}
</script>

<style lang="scss">
@keyframes dropdown {
    to{transform: translateY(0%);}
}

.hamburger-menu{
    display: none;
}

#nav{
    transform: translateY(-100%);

    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;

    display: flex;
    flex-flow: row;
    justify-content: flex-end;
    align-items: center;
    gap: 1.5em;

    width: 100%;
    font-size: 16px;
    padding: 1em;

    background-color: var(--white);

    animation: dropdown 2s 1s ease-in-out;
    animation-fill-mode: forwards;

    
    
    .link{
        text-decoration: none;
        color: var(--regular);
        font-weight: bold;
        // transition: transform 0.1s ease-in-out;
        
        &#logo{
            color: var(--medium);
            margin-right: auto;
            font-size: 18pt;
            font-family: var(--font-accent);
            letter-spacing: 0.05em;
            font-weight: 900;
            
            #logo-icon{
                display: block;
                width: 1.25em;
            }
        }

        &#donate-link{
            background-color: var(--regular);
            color: var(--white);
            padding: 0.25em 0.75em;
            border-radius: var(--border-radius-full);
        }

        &:hover{
            cursor: pointer;
            filter: brightness(0.9);
            // transform: scale(1.05);
            text-decoration: underline;
        }

        &:focus {
            text-decoration: none;
            outline: 2px dashed var(--regular);
            outline-offset: 4px;
            border-radius: var(--border-radius-sm);
        }
    }
}

@media screen and (max-width: 768px) {
// .nav-wrapper{
//     max-width: 100%;
// }

    .hamburger-menu{
        position: fixed;

        display: block;
        background-color: var(--dark);
        color: var(--white);

        right: 1em;
        top: 1em;
        padding: 0.5em;
        border-radius: 10em;
        z-index: 11;
        .line{
            position: relative;
            content: "";
            display: block;
            width: 2em;
            height: 0.25em;
            background-color: var(--white);
            margin: 0.5em;
            transition: all 1s ease-in-out;
        }

        &.open{
            .top{
                transform: translateY(0.75em) rotate(-45deg);
            }
            .middle{
                opacity: 0;
            }
            .bottom{
                transform: translateY(-0.75em) rotate(45deg);
            }
        }
    }

    #nav{
        transform: translateY(-100%);
        // max-height: 0;
        animation: none;
        flex-flow: column;
        transition: all 0.5s ease-in-out;
        overflow: hidden;
        font-size: 1.15rem;
        padding: 1.5rem 1rem;
        gap: 1.1rem;
        box-shadow: 0 0 5px -3px var(--dark);

        &.open{
            // max-height: 100%;
            transform: translateY(0);
        }
    }
}
</style>